import {configureStore} from '@reduxjs/toolkit';
// Or from '@reduxjs/toolkit/query/react'
import {setupListeners} from '@reduxjs/toolkit/query';
import {noomApi} from "./api.js";
import authReducer from './slices/authSlice';
import smartIdReducer from './slices/smartIdSlice';

export const store = configureStore({
  reducer: {
    // Add the generated reducer as a specific top-level slice
    [noomApi.reducerPath]: noomApi.reducer,
    auth: authReducer,
    smartId: smartIdReducer,
   
  },
  // Adding the api middleware enables caching, invalidation, polling,
  // and other useful features of `rtk-query`.
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(noomApi.middleware),
})

// optional, but required for refetchOnFocus/refetchOnReconnect behaviors
// see `setupListeners` docs - takes an optional callback as the 2nd arg for customization
setupListeners(store.dispatch)